import { Button } from '@mui/material';
import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import RHFAutoComplete from 'src/components/elements/AutoComplete/RHFAutoComplete';
import { useJobs } from 'src/hooks/query/jobs';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';

export interface ApplyJobFormValues {
  jobId: string;
}

const validationSchema = yup.object().shape({
  jobId: yup.string().required('Job Required'),
});

interface ApplyToJobFormProps {
  loading: boolean;
  onSubmit: (data: ApplyJobFormValues) => void;
}

const ApplyToJobForm = function ApplyToJobForm(props: ApplyToJobFormProps) {
  const { loading, onSubmit } = props;
  const { jobsOptions, jobsLoading } = useJobs();
  const resolver = useYupValidationResolver(validationSchema);
  const methods = useForm<ApplyJobFormValues>({
    resolver,
  });
  const {
    handleSubmit,
  } = methods;

  const submitHandler: SubmitHandler<ApplyJobFormValues> = async (data) => {
    console.log('data', data);
    onSubmit(data);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)} className="bg-white p-10 flex gap-4 justify-center items-center flex-col">
        <div className="font-bold">Apply Job</div>
        <div className="w-[280px] flex-shrink-0">
          <RHFAutoComplete
            control={methods.control}
            name="jobId"
            label="Job"
            loading={jobsLoading}
            options={jobsOptions}
            disabled={loading}
          />
        </div>
        <div className="w-full justify-center flex">
          <Button disabled={loading} variant="contained" type="submit" size="small" className="font-medium rounded-full">Apply Job</Button>
        </div>
      </form>
    </FormProvider>
  );
};

ApplyToJobForm.defaultProps = {

};

ApplyToJobForm.propTypes = {

};

export default ApplyToJobForm;
